import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { DropTargetOptions, FileItem, HttpClientUploadService } from '@wkoza/ngx-upload';

@Component({
    selector: 'addbasefile',
    templateUrl: 'addbasefile.component.html',
    styleUrls: ['addbasefile.component.scss'],
})
export class AddBaseFileComponent implements OnInit, OnChanges {
    @Input() public displayStopValue: boolean = false;
    @Input() public uploader: HttpClientUploadService;
    @Input() public title;
    @Input() public dataLabel;
    @Input() public bskType;
    @Input() public bskDocAddList;
    @Input() public ctrlDouble;
    @Input() public enterVariable;
    @Input() public requiredVariable;
    @Input() public fileMode;
    @Input() public disabledSend;
    @Input()
    @Output()
    public visible: boolean;

    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();

    @Output()
    public onClickAdd: EventEmitter<any> = new EventEmitter();

    @Output()
    public onClickStop: EventEmitter<any> = new EventEmitter();

    @Output()
    public onSetIndex: EventEmitter<any> = new EventEmitter();

    @Output()
    public onRemoveItem: EventEmitter<any> = new EventEmitter();

    options: DropTargetOptions = {
        color: 'dropZoneColor',
        colorDrag: 'dropZoneColorDrag',
        colorDrop: 'dropZoneColorDrop',
        multiple: true,
    };

    constructor() {}

    public ngOnInit() {
        if (this.enterVariable === false && this.fileMode === true) {
            this.onClickAdd.emit(null);
        }
    }

    public ngOnChanges() {}

    public setIndex(event, i) {
        this.onSetIndex.emit({
            item: event,
            index: i,
        });
    }

    public removeItem(event) {
        this.onRemoveItem.emit(event);
    }

    public clickAdd(event) {
        this.onClickAdd.emit(event);
    }

    public clickStop(event) {
        this.uploader.cancelAll();
        this.onClickStop.emit(event);
    }

    public close(event) {
        this.onClose.emit(event);
    }
}
